export default __webpack_public_path__ + "static/homepage_carousel_video_mobile-3ece2a966173e2245deab639cfd879ce.mp4";